module.exports = __webpack_public_path__ + "b15309ce2e0b39c3728b630e07b61616.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/pants-blank.jpg
// module id = 792
// module chunks = 0